import React from "react";
import { EnhancedHeader } from "@/components/ui";
import { Separator } from "@/components/ui/separator";
import { ScrollArea } from "@/components/ui/scroll-area";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <EnhancedHeader
        title="Privacy Policy"
        backPath="/user-settings"
        coloredText={true}
        rightContent={null}
        showBackButton={true}
      />

      <div className="max-w-md mx-auto px-4 pb-10">
        <div className="bg-zinc-900 rounded-xl overflow-hidden mb-4">
          <div className="p-4">
            <p className="text-sm text-gray-400 mb-4">Last Updated: May 19, 2025</p>
            
            <ScrollArea className="h-[calc(100vh-180px)] pr-4">
              <div className="space-y-6">
                <section>
                  <h3 className="text-green-400 font-medium mb-2">1. Introduction</h3>
                  <p className="text-sm text-gray-300">
                    Spar Legends ("we", "our", or "us") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you use our mobile application and services.
                  </p>
                </section>

                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">2. Information We Collect</h3>
                  <p className="text-sm text-gray-300 mb-2">
                    <span className="font-medium">Personal Data:</span> We may collect personally identifiable information such as your name, email address, and profile information when you create an account.
                  </p>
                  <p className="text-sm text-gray-300 mb-2">
                    <span className="font-medium">Usage Data:</span> We collect information about how you interact with our application, including game progress, preferences, and activity logs.
                  </p>
                  <p className="text-sm text-gray-300">
                    <span className="font-medium">Device Information:</span> We collect information about your device, including IP address, operating system, browser type, and device identifiers.
                  </p>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">3. How We Use Your Information</h3>
                  <p className="text-sm text-gray-300 mb-2">
                    We use your information to:
                  </p>
                  <ul className="list-disc list-inside text-sm text-gray-300 space-y-1 ml-2">
                    <li>Provide, maintain, and improve our services</li>
                    <li>Process and complete transactions</li>
                    <li>Send you technical notices and support messages</li>
                    <li>Respond to your comments and questions</li>
                    <li>Develop new products and services</li>
                    <li>Monitor usage patterns and analyze trends</li>
                  </ul>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">4. Data Sharing and Disclosure</h3>
                  <p className="text-sm text-gray-300 mb-2">
                    We do not sell your personal information. We may share your information with:
                  </p>
                  <ul className="list-disc list-inside text-sm text-gray-300 space-y-1 ml-2">
                    <li>Service providers who assist in delivering our services</li>
                    <li>Partners for marketing purposes (with your consent)</li>
                    <li>Legal authorities when required by law</li>
                  </ul>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">5. Security</h3>
                  <p className="text-sm text-gray-300">
                    We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.
                  </p>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">6. Your Data Rights</h3>
                  <p className="text-sm text-gray-300 mb-2">
                    Depending on your location, you may have the right to:
                  </p>
                  <ul className="list-disc list-inside text-sm text-gray-300 space-y-1 ml-2">
                    <li>Access your personal information</li>
                    <li>Correct inaccurate information</li>
                    <li>Delete your personal information</li>
                    <li>Restrict or object to processing</li>
                    <li>Data portability</li>
                    <li>Withdraw consent</li>
                  </ul>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">7. Children's Privacy</h3>
                  <p className="text-sm text-gray-300">
                    Our services are not intended for individuals under the age of 13. We do not knowingly collect personal information from children under 13. If you become aware that a child has provided us with personal information, please contact us.
                  </p>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">8. Cookies and Tracking Technologies</h3>
                  <p className="text-sm text-gray-300">
                    We use cookies and similar tracking technologies to collect information about your activities on our platform. You can control cookies through your browser settings, but disabling cookies may limit your use of certain features.
                  </p>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">9. Changes to This Privacy Policy</h3>
                  <p className="text-sm text-gray-300">
                    We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
                  </p>
                </section>
                
                <Separator className="bg-zinc-800" />

                <section>
                  <h3 className="text-green-400 font-medium mb-2">10. Contact Us</h3>
                  <p className="text-sm text-gray-300">
                    If you have any questions about this Privacy Policy or our data practices, please contact us at:
                  </p>
                  <p className="text-sm text-green-400 mt-2">
                    Email: privacy@sparlegends.com
                  </p>
                </section>
              </div>
            </ScrollArea>
          </div>
        </div>
      </div>
    </div>
  );
}